// types
import { i18nEaiDeliveryContracts } from 'models/i18n';

// ==============================|| I18N SK DELIVERY CONTRACTS ||============================== //

const skEaiDeliveryContracts: i18nEaiDeliveryContracts = {
  createDeliveryContractWizard: {
    title: 'Vytvorenie dlhodobého kontraktu',
    step01: 'Zmluvné strany',
    step02: 'Predmet dodávky',
    save: 'Vytvoriť kontrakt'
  },
  deliveryContractList: {
    title: 'Zoznam dlhodobých kontraktov',
    searchInput: 'Zadajte názov/ID/kód',
    createEntityButton: 'Vytvoriť kontrakt',
    columns: {
      id: 'ID',
      code: 'Kód',
      type: 'Typ',
      name: 'Názov',
      startDate: 'Začiatok',
      endDate: 'Koniec',
      status: 'Stav'
    },
    filter: {
      validityFrom: 'Platnosť od',
      validityTo: 'Platnosť do',
      status: 'Status',
      type: 'Typ'
    }
  },
  deliveryContractDetail: {
    contractData: {
      title: 'Informácie o kontrakte',
      basicInfo: 'Základné informácie',
      contractType: 'Typ kontraktu'
    },
    deliveryPoints: {
      title: 'Odberné miesta',
      columns: {
        deliveryPointId: 'ID odberného miesta',
        name: 'Názov odberného miesta',
        eic: 'EIC',
        actions: 'Akcie'
      },
      addDeliveryPoint: 'Pridať odberné miesto'
    }
  },
  input: {
    ProducerMarketParticipant: 'Dodávateľ',
    ConsumerMarketParticipant: 'Odberateľ',
    DeliveryContractType: 'Typ kontraktu',
    Amount: 'Objem elektrickej energie',
    Unit: 'Jednotka',
    UnitPrice: 'Jednotková cena',
    IndexPriceRatio: 'Marža obchodníka',
    StartDate: 'Platnosť od',
    EndDate: 'Platnosť do',
    Id: 'ID',
    Name: 'Názov',
    Description: 'Popis',
    Code: 'Kód',
    DeliveryPoint: 'Odberné miesto'
  },
  validation: {
    'ProducerMarketParticipant-required': 'Dodávateľ je povinný',
    'ConsumerMarketParticipant-required': 'Odberateľ je povinný',
    'DeliveryContractType-required': 'Typ kontraktu je povinný',
    'Amount-required': 'Objem elektrickej energie je povinný',
    'Amount-number':
      'Objem elektrickej energie musí byť v tvare kladného desatinného čísla (2 desatinné miesta)',
    'Unit-required': 'Jednotka je povinná',
    'UnitPrice-required': 'Jednotková cena je povinná',
    'UnitPrice-number':
      'Jednotková cena musí byť v tvare kladného desatinného čísla (2 desatinné miesta)',
    'IndexPriceRatio-number':
      'Marža obchodníka musí byť v tvare desatinného čísla (2 desatinné miesta)',
    'IndexPriceRatio-required': 'Marža obchodníka je povinná',
    'IndexPriceRatio-max':
      'Marža obchodníka musí byť hodnota v rozmedzí 0-1000',
    'StartDate-required': 'Dátum platnosti od je povinný',
    'StartDate-beforeEndDate':
      'Dátum platnosti od musí byť dátum menší ako dátum platnosti do',
    'EndDate-required': 'Dátum platnosti do je povinný',
    'EndDate-afterStartDate':
      'Dátum platnosti do musí byť dátum väčší ako dátum platnosti od',
    'Name-required': 'Meno je povinné',
    'Name-length': 'Dĺžka mena musí byť maximálne 256 znakov',
    'Code-required': 'Kód je povinný',
    'Code-length': 'Dĺžka kódu musí byť maximálne 64 alfanumerickýc znakov',
    'Description-length': 'Dĺžka popisu musí byť maximálne 2000 znakov'
  }
};

export default skEaiDeliveryContracts;
